// extracted by mini-css-extract-plugin
export default {"light-text-color":"rgb(105, 111, 119)","stalled-content-width":"700px","headline":"styles_headline__+x8fR","body":"styles_body__ufNdH"};